module.exports = __webpack_public_path__ + "media/trail/icons-controls-2d-a1c59dc3.svg";